import { useEffect } from 'react';
import type { SocialProviderConfig } from '../../constants/socialProviders';

function FacebookSocialLogin({ providerConfig }: { providerConfig: SocialProviderConfig }) {
  useEffect(() => {

    const params = new URLSearchParams({
      client_id: providerConfig.clientId ?? '',
      redirect_uri: providerConfig.callbackUrl ?? '',
      response_type: 'code',
      scope: 'email,public_profile',
    });

    window.location.href = `https://www.facebook.com/v18.0/dialog/oauth?${params.toString()}`;
  }, [providerConfig.callbackUrl, providerConfig.clientId]);

  return (
    <div
      style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
        background: '#ffffff',
        color: '#333',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderTop: '4px solid #1877F2',
            borderRadius: '50%',
            width: 50,
            height: 50,
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px',
          }}
        />
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default FacebookSocialLogin;
